import React, { useContext } from "react";
import AdsTable from "./AdsTable";
import { NavLink } from "react-router-dom";
import { Button, Space } from "antd";
import { context } from "../../context/context";

const AdsSection = () => {
    // context
    const {
        setAdCover,
        setAdCoverId,
        setAdDescription,
        setAdEndDate,
        setAdLimit,
        setAdLink,
        setAdNumOfSlide,
        setAdPosition,
        setAdPriority,
        setAdStartDate,
        setAdTags,
        setAdTitle,
        setSelectedAdId,
    } = useContext(context);
    // functions
    const handleEmptyFields = () => {
        setSelectedAdId();
        setAdCover([]);
        setAdCoverId();
        setAdDescription();
        setAdEndDate();
        setAdLimit();
        setAdLink();
        setAdNumOfSlide();
        setAdPosition();
        setAdPriority();
        setAdStartDate();
        setAdTags([]);
        setAdTitle();
    };
    return (
        <>
            <Space
                direction="vertical"
                style={{ width: "100%", justifyContent: "space-between" }}
                align="end"
            >
                <NavLink to="/addAdvertisement">
                    <Button onClick={handleEmptyFields} type="primary">
                        اضافه کردن تبلیغ جدید
                    </Button>
                </NavLink>
            </Space>
            <AdsTable />
        </>
    );
};

export default AdsSection;
